import { Link } from "react-router-dom";

import { Badge } from "@/components/Badge";
import {
  directionLabel,
  money,
  num,
  sessionLabel,
  trendLabel,
} from "@/lib/format";
import { directionColor, histogramColor, trendColor } from "@/lib/theme";
import type { Signal } from "@/lib/types";

export function SignalCard({ signal }: { signal: Signal }) {
  return (
    <div className="card">
      <Link
        className="card-link"
        to={`/stock/${encodeURIComponent(signal.symbol)}`}
      >
        <div className="card-head">
          <div className="card-head-main">
            <div className="symbol">{signal.symbol}</div>
            <div className="name">{signal.name}</div>
          </div>
          <div className="card-head-side">
            <Badge
              label={directionLabel(signal.direction)}
              color={directionColor(signal.direction)}
            />
            <div className="price">{money(signal.price)}</div>
          </div>
        </div>

        <div className="metrics">
          <Metric label="RSI" value={num(signal.rsi, 1)} />
          <Metric
            label="MACD"
            value={num(signal.macd_histogram, 3)}
            color={histogramColor(signal.macd_histogram)}
          />
          <Metric
            label="추세"
            value={trendLabel(signal.trend)}
            color={trendColor(signal.trend)}
          />
          <Metric
            label="점수"
            value={`▲${signal.buy_score} ▼${signal.sell_score}`}
          />
        </div>

        <p className="session">{sessionLabel(signal.session)} 기준</p>
      </Link>
    </div>
  );
}

function Metric({
  label,
  value,
  color,
}: {
  label: string;
  value: string;
  color?: string;
}) {
  return (
    <div className="metric">
      <div className="metric-label">{label}</div>
      <div className="metric-value" style={color ? { color } : undefined}>
        {value}
      </div>
    </div>
  );
}
